import {HTTP_REQUEST_AUTH} from "./requestAxios";
import {EVENT} from "@/constants/endPoints";

export const GetListEvent = (payload) => HTTP_REQUEST_AUTH.get(EVENT.LIST_EVENTS, {params: payload});
export const GetDetailEvent = (payload) => HTTP_REQUEST_AUTH.get(EVENT.GET_DETAIL_EVENT, {params: payload});
export const CreateEvent = (params) => HTTP_REQUEST_AUTH.post(EVENT.CREATE_EVENT, params);
export const DeleteEventInDay = (params) => HTTP_REQUEST_AUTH.post(EVENT.DELETE_EVENT_IN_DAY, params);
export const DeleteEvent = (params) => HTTP_REQUEST_AUTH.post(EVENT.DELETE_EVENT, params);
export const UpdateEvent = (params) => HTTP_REQUEST_AUTH.post(EVENT.UPDATE_EVENT, params);